import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { MarketingTemplate } from "../../marketing.types";

export const requestGetMarketingTemplates = async (
  approved?: boolean
): Promise<MarketingTemplate[]> => {
  return await instance.get(ApiRoutesMarketing.Templates, {
    params: approved ? { approved: true } : undefined
  });
};
